import { JwtHelperService } from "@auth0/angular-jwt";
import { Token } from "./abstractions/token.model";

export class EmailVerificationToken implements Token<string> {
    protected jwtHelper = new JwtHelperService();

    public issuer: string;
    public audience: string[];
    public expiresAt: Date;
    public issuedAt: Date;
    public subject: string;
    protected token: string;
    public anredeId: string | null;
    public titelId: string | null;
    public firstname: string | null;
    public lastname: string | null;

    public get email(): string {
        return this.subject;
    }
    public scopes: string[];

    public get isExpired(): boolean {
        return this.jwtHelper.isTokenExpired(this.token);
    }

    public get type(): string {
        return EmailVerificationToken.name;
    }

    constructor(public base64Token: string) {
        if (!base64Token)
            return;

        // decode the base64token
        this.token = atob(base64Token);

        let decodedToken: any = this.jwtHelper.decodeToken(this.token);

        if (!decodedToken.iss)
            throw new Error("issuer can't be empty");

        if (!decodedToken.aud)
            throw new Error("audience can't be empty");

        if (!decodedToken.exp)
            throw new Error("expires at can't be empty");

        if (!decodedToken.iat)
            throw new Error("issued at can't be empty");

        if (!decodedToken.sub)
            throw new Error("subject can't be empty");

        if (!decodedToken.scope)
            throw new Error("scopes can't be empty");

        this.issuer = decodedToken.iss;
        this.audience = decodedToken.aud;
        this.expiresAt = decodedToken.exp;
        this.issuedAt = decodedToken.iat;
        this.subject = decodedToken.sub;
        this.scopes = decodedToken.scope;
        this.anredeId = decodedToken.anredeid;
        this.titelId = decodedToken.titelid;
        this.firstname = decodedToken.firstname;
        this.lastname = decodedToken.lastname;
    }

    public toJwtToken(): string {
        return this.token;
    }

    public toBase64JwtToken(): string {
        return this.base64Token;
    }
}